/* eslint-disable prettier/prettier */
//Services
import CentroHemodialiseService from "./CentroHemodialiseService";

export default {
  mixins: [CentroHemodialiseService],
  data() {
    return {
      idRnpPrestador: -1,
      loadingPrestador: false,
      podeEnviarArquivo: false,
      codigoUnimed: "",
      iniciado: false,
      tipoQuestionario: {
        idTipoQuestionario: "",
        tipoQuestionario: ""
      },
      id: "",
      payloadServicos: [],
      payloadEspecialidades: [],
      payloadAbrangencias: [],
      objetosParaUpload: [],
      render: false,
      status: ""
    };
  },
  beforeMount() {
    this.iniciarQuestionario();
  },
  methods: {
    iniciarQuestionario() {
      this.$store.commit("clearDataAps");
      this.$store.commit("setFetchedAps", false);
      this.$store.commit("setTemAps", false);
      this.$store.dispatch("recuperarIdPrestador");
      const id = this.$store.getters.getPrestadorId;
      const url = this.CriarUrl({
        resource: `questionario?rnpPrestadorId=${id}`
      });
      this.$store.dispatch("puxarDadosSalvosServidor", url).finally(() => {
        this.preencheDadosTipoQuestionario();
        this.preencheDadosIdQuestionario();
        this.puxarAps();
        this.render = true;
      });
    },
    captarPayloadServicos(payload) {
      this.payloadServicos = [...payload.servicos];
      this.payloadEspecialidades = [...payload.especialidades];
      this.payloadAbrangencias = [...payload.abrangencias];
    },
    FormataDadosParaEnviar(rascunho) {
      const dadosPost = {
        horarioFuncionamento: this.$refs.dadosCadastrais.preparaDadosHorarioFuncionamento(),
        tipoQuestionario: this.preparaDadosTipoQuestionario(),
        remuneracoes: this.$refs.objetoInfraestrutura.preparaDadosRemuneracoes(
          false
        ),
        prontuarios: this.$refs.objetoInfraestrutura.preparaDadosProntuarios(
          false
        ),
        complexidades: [],
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        transplantes: [],
        abrangencias: [...this.payloadAbrangencias],
        servicosTerceirizados: this.$refs.objetoInfraestrutura.preparaDadosServicosTerceirizados(
          false
        ),
        servicosPublicos: [],
        atendimentoIntercambio: this.$refs.atendimentoIntercambio.preparaDados(),
        diretorTecnico: this.$refs.diretorTecnico.preparaDadosDiretorTecnico(),
        status: rascunho ? 'RASCUNHO' : 'FINALIZADO'
      };
      this.$store.commit("setFetched", false);
      console.log("post", dadosPost);
      return dadosPost;
    },
    FormataDadosParaAlterar(rascunho) {
      const dadosPut = {
        id: this.id,
        horarioFuncionamento: this.$refs.dadosCadastrais.preparaDadosHorarioFuncionamento(),
        tipoQuestionario: this.preparaDadosTipoQuestionario(),
        remuneracoes: this.$refs.objetoInfraestrutura.preparaDadosRemuneracoes(
          true
        ),
        prontuarios: this.$refs.objetoInfraestrutura.preparaDadosProntuarios(
          true
        ),
        complexidades: [],
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        transplantes: [],
        abrangencias: [...this.payloadAbrangencias],
        servicosTerceirizados: this.$refs.objetoInfraestrutura.preparaDadosServicosTerceirizados(
          true
        ),
        servicosPublicos: [],
        atendimentoIntercambio: this.$refs.atendimentoIntercambio.preparaDados(),
        diretorTecnico: this.$refs.diretorTecnico.preparaDadosDiretorTecnico(),
        status: rascunho ? 'RASCUNHO' : 'FINALIZADO'
      };
      this.$store.commit("setFetched", false);
      console.log("put", dadosPut);
      return dadosPut;
    },
    async salvar(rascunho = false) {
      this.mostrarModalSalvar = false;
      this.salvando = true;
      const { id } = this.$route.params;
      this.idRnpPrestador = id;
      await this.salvarQuestionario(id, rascunho)
        .then(() => {
          this.$store.commit("setFetched", false);
          this.$store.commit("setFetchedAps", false);
          this.$store.commit("setPuxarCliente", false);
          return this.uploadArquivos();
        })
        .then(() => {
          this.salvando = false;
          console.log("Questionario salvo com sucesso ");
        })
        .catch(error => {
          console.log(error);
        });
    },
    async salvarQuestionario(idRnpPrestador, rascunho) {
      if (this.id) {
        await this.putCentroHemodialise(this.FormataDadosParaAlterar(rascunho));
        await this.salvarAps(this.id);
        if (!rascunho) {
          this.$router.push("/recursos-proprios");
        } else {
          this.mostrarModalRascunho = false;
          this.status = 'RASCUNHO';
          this.iniciarQuestionario();
        }
      } else {
        const { data } = await this.postCentroHemodialise(
          idRnpPrestador,
          this.FormataDadosParaEnviar(rascunho)
        );
        await this.salvarAps(data.id);
        if (!rascunho) {
          this.$router.push("/recursos-proprios");
        } else {
          this.mostrarModalRascunho = false;
          this.status = 'RASCUNHO';
          this.iniciarQuestionario();
        }
      }
    },
    async salvarAps(id) {
      const payloadAps = this.$store.getters.getPayloadCliente;

      if (Object.keys(payloadAps).length == 0) return;

      await this.putAps(id, payloadAps);
    },
    voltar() {
      this.$store.commit("clearDataAps");
      this.$store.commit("setTemAps", false);
      this.$router.push("/recursos-proprios");
    },
    fecharQuestionario(valor) {
      if (!valor) {
        this.$emit("input", false);
      }
    },
    async preencheDadosTipoQuestionario() {
      const url = this.CriarUrl({ resource: "tipo_questionario" });

      const query = {
        tipo: "Form_Centro_Hemodialise",
        // tipo: "Form_ID_APS",
        url
      };
      const tipoForm = await this.$store.dispatch(
        "puxarTiposQuestionarios",
        query
      );

      this.tipoQuestionario = tipoForm;
    },
    preparaDadosTipoQuestionario() {
      return this.tipoQuestionario;
    },
    preencheDadosIdQuestionario() {
      const data = this.$store.getters.getPayloadServidor();

      if (data) {
        if (data.id) {
          this.id = data.id;
          this.status = data.status;
        }
      }
    },
    puxarAps() {
      if (this.id) {
        const urlAps = this.CriarUrl({
          resource: `aps/questionario/${this.id}`
        });
        this.$store.dispatch("puxarDadosSalvosServidorAps", urlAps);
      } else {
        this.$store.commit("setHabilitarQuestionarioAps", true);
      }
    },
    preparaDadosIdQuestionario() {
      return this.id;
    },
    uploadArquivoHandler(objetoUpload) {
      const { formData } = objetoUpload;

      const existe = this.objetosParaUpload.find(
        obj => obj.formData === formData
      );

      if (existe) return;

      this.objetosParaUpload.push(objetoUpload);
    },
    uploadArquivos() {
      this.objetosParaUpload.forEach(obj => {
        const { formData, campo } = obj;

        return this.putUploadArquivo(formData, campo, porcentagem => {
          console.log(porcentagem);
        });
      });
    }
  },
  computed: {
    enviarDesativado() {
      return this.objetoInformacoes.length <= 0;
    }
  }
};
